<app-loading-overlay
	[show]="showLoadingOverlay"
	[title]="loadingOverlayTitle"
	[subtitle]="loadingOverlaySubTitle"
></app-loading-overlay>
<div class="d-flex flex-column vh-100">
	<div class="modal-header">
		<ng-container *ngIf="header">
			<ng-template [ngTemplateOutlet]="header"></ng-template>
		</ng-container>
		<ng-container *ngIf="!header">
			<div class="w-100 text-center">
				<h5>
					<strong>{{ title }}</strong>
				</h5>
			</div>
			<button
				(click)="clickCloseBtnWizard.emit()"
				type="button"
				class="btn-close close pull-right"
				aria-label="Close"
			>
				<span aria-hidden="true" class="visually-hidden">&times;</span>
			</button>
		</ng-container>
	</div>
	<div class="modal-body bg-zindex">
		<div class="my-4">
			<ng-template [ngTemplateOutlet]="body"></ng-template>
		</div>
	</div>
	<div class="modal-footer">
		<ng-template [ngTemplateOutlet]="footer"></ng-template>
	</div>
</div>
